import { mergeClasses } from "@fluentui/react-components";
import { VaultMeetingChip } from "apps/project-iq/components/VaultMeetingChip/VaultMeetingChip";
import {
  getDayDateLabel,
  getLongDayLabel,
  getMeetingsForDay,
  getShortDayName,
  getWeekDays,
  isSameDay,
} from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.utils";
import { useVaultMeetingsWeekGridStyles } from "./VaultMeetingsWeekGrid.styles";
import { IVaultMeetingsWeekGridProps } from "./VaultMeetingsWeekGrid.types";

export const VaultMeetingsWeekGrid = ({
  weekStart,
  today,
  meetings,
}: IVaultMeetingsWeekGridProps): JSX.Element => {
  const styles = useVaultMeetingsWeekGridStyles();

  return (
    <div className={styles.scroller}>
      <div className={styles.grid} role="list" aria-label="Meetings by day">
        {getWeekDays(weekStart).map((day, index) => {
          const isToday = isSameDay(day, today);
          const dayMeetings = getMeetingsForDay(meetings, day);
          return (
            <div
              key={day.getTime()}
              role="listitem"
              aria-label={`${getLongDayLabel(day)}${isToday ? ", today" : ""}, ${dayMeetings.length} ${dayMeetings.length === 1 ? "meeting" : "meetings"}`}
              className={mergeClasses(
                styles.dayColumn,
                index === 0 && styles.dayColumnFirst,
              )}
            >
              <p className={styles.dayName} aria-hidden="true">
                {getShortDayName(day)}
              </p>
              <p className={styles.dateRow}>
                <span
                  aria-hidden="true"
                  className={mergeClasses(
                    styles.date,
                    isToday && styles.dateToday,
                  )}
                  data-today={isToday ? "true" : undefined}
                >
                  {getDayDateLabel(day)}
                </span>
              </p>
              <ul className={styles.meetingList}>
                {dayMeetings.map((meeting) => (
                  <VaultMeetingChip key={meeting.id} meeting={meeting} />
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};
